import React, { useState, useEffect } from "react";
import '../styles/Flipbook.css';

export default function FlipBook({ pages = [] }) {
  const [index, setIndex] = useState(0);
  const [turn, setTurn] = useState(null); // "next" | "prev" | null

  const goNext = () => {
    if (index + 2 < pages.length) {
      setTurn("next");
      setTimeout(() => {
        setIndex(idx => idx + 2);
        setTurn(null);
      }, 900);
    }
  };

  const goPrev = () => {
    if (index - 2 >= 0) {
      setTurn("prev");
      setTimeout(() => {
        setIndex(idx => idx - 2);
        setTurn(null);
      }, 900);
    }
  };

  return (
    <div className="book-wrapper">
      <div className="book">

        {/* Página izquierda */}
        <div className={`page left ${turn === "prev" ? "flip-back" : ""}`}>
          {pages[index] && <img src={pages[index]} alt="left" />}
        </div>

        {/* Página derecha */}
        <div className={`page right ${turn === "next" ? "flip" : ""}`}>
          {pages[index + 1] && <img src={pages[index + 1]} alt="right" />}
        </div>
      </div>

      <div className="controls">
        <button onClick={goPrev}>⬅️ Anterior</button>
        <button onClick={goNext}>➡️ Siguiente</button>
      </div>
    </div>
  );
}


/*import React, { useState, useRef } from "react";
import "../styles/Flipbook.css";

export default function FlipBook({ pages = [] }) {
  const [current, setCurrent] = useState(0);
  const [angle, setAngle] = useState(0);
  const [isFlipping, setIsFlipping] = useState(false);

  const nextPage = () => {
    if (current >= pages.length - 1 || isFlipping) return;
    setIsFlipping(true);

    // animación hacia la izquierda
    setAngle(-180);

    setTimeout(() => {
      setCurrent((p) => p + 1);
      setAngle(0);
      setIsFlipping(false);
    }, 450);
  };

  const prevPage = () => {
    if (current <= 0 || isFlipping) return;
    setIsFlipping(true);

    // animación hacia la derecha
    setAngle(180);

    setTimeout(() => {
      setCurrent((p) => p - 1);
      setAngle(0);
      setIsFlipping(false);
    }, 450);
  };

  return (
    <div className="book-wrapper">
      <div className="book-container">
        {pages.map((p, i) => (
          <div
            key={i}
            className={`page ${i === current ? "visible" : ""}`}
            style={{
              transform:
                i === current ? `rotateY(${angle}deg)` : "rotateY(0deg)",
            }}
          >
            <img src={p} alt={`page-${i}`} />
          </div>
        ))}
      </div>

      <div className="controls">
        <button onClick={prevPage} disabled={current === 0 || isFlipping}>
          ◀ Anterior
        </button>
        <button
          onClick={nextPage}
          disabled={current === pages.length - 1 || isFlipping}
        >
          Siguiente ▶
        </button>
      </div>
    </div>
  );
}
*/


/**
 * FlipBook props:
 * - pages: array de URLs de imágenes (cada elemento es una página).
 * - startPage: índice inicial (0).
 * - width, height: dimensiones del libro en px o %.
 */
/*
export default function FlipBook({ pages = [], startPage = 0, width = "800px", height = "500px" }) {
  const [current, setCurrent] = useState(startPage);
  const [isFlipping, setIsFlipping] = useState(false);
  const [direction, setDirection] = useState(null); // 'next' | 'prev'
  const bookRef = useRef(null);

  useEffect(() => {
    // ajusta current si fuera necesario
    if (current < 0) setCurrent(0);
    if (current > Math.max(0, pages.length - 1)) setCurrent(pages.length - 1);
  }, [pages.length]);

  function goNext() {
    if (isFlipping || current >= pages.length - 1) return;
    setDirection("next");
    setIsFlipping(true);
    // espera la animación (match con CSS: 800ms)
    setTimeout(() => {
      setCurrent((c) => Math.min(pages.length - 1, c + 1));
      setIsFlipping(false);
      setDirection(null);
    }, 800);
  }

  function goPrev() {
    if (isFlipping || current <= 0) return;
    setDirection("prev");
    setIsFlipping(true);
    setTimeout(() => {
      setCurrent((c) => Math.max(0, c - 1));
      setIsFlipping(false);
      setDirection(null);
    }, 800);
  }

  // Determine which two images are visible as left/right spreads.
  // We'll show current as left page for spread layout (you can invert if prefieres).
  const leftIndex = current;
  const rightIndex = Math.min(current + 1, pages.length - 1);

  return (
    <div className="flipbook-wrapper">
      <div
        className="flipbook"
        ref={bookRef}
        style={{ width: width, height: height }}
        aria-live="polite"
      >
      
        <div className="spine" />

        
        <div className="page left-page">
          <div className="page-face">
            {pages[leftIndex] ? (
              <img src={pages[leftIndex]} alt={`Página ${leftIndex + 1}`} draggable="false" />
            ) : (
              <div className="blank">—</div>
            )}
          </div>
        </div>

        
        <div className="page right-page">
          <div className="page-face">
            {pages[rightIndex] ? (
              <img src={pages[rightIndex]} alt={`Página ${rightIndex + 1}`} draggable="false" />
            ) : (
              <div className="blank">—</div>
            )}
          </div>
        </div>

        
        <div
          className={`flip-layer ${isFlipping ? "flipping" : ""} ${direction === "next" ? "to-next" : ""} ${
            direction === "prev" ? "to-prev" : ""
          }`}
        >
          
          <div className="flip-page front">
            
            <img
              src={direction === "next" ? pages[rightIndex] : pages[leftIndex]}
              alt="flipping"
              draggable="false"
            />
          </div>
          <div className="flip-page back">
            
            <div className="back-surface" />
          </div>
        </div>

        
        <div className="flip-controls">
          <button onClick={goPrev} disabled={current <= 0 || isFlipping} aria-label="Anterior">
            ‹
          </button>
          <div className="page-indicator">{`${current + 1} / ${pages.length}`}</div>
          <button onClick={goNext} disabled={current >= pages.length - 1 || isFlipping} aria-label="Siguiente">
            ›
          </button>
        </div>
      </div>
    </div>
  );
}*/
